var checkFailingMutations = function (selectedAccounts, failingMutations, invalidFieldErrors) {
    var isAllMutationsFailed = selectedAccounts.length === failingMutations.length;
    if ((invalidFieldErrors === null || invalidFieldErrors === void 0 ? void 0 : invalidFieldErrors.code) === "400") {
        return {
            mutatedAccountsWithErrors: [],
            newSelectedAccounts: [selectedAccounts[0]],
            accountsMutationErrors: "forms.errors.page.invalid_data",
            fieldErrors: invalidFieldErrors,
        };
    }
    if (isAllMutationsFailed) {
        return {
            mutatedAccountsWithErrors: [],
            newSelectedAccounts: [selectedAccounts[0]],
            accountsMutationErrors: "forms.errors.page.api",
        };
    }
    var newSelectedAccounts = selectedAccounts.filter(function (account) { return !failingMutations.includes(account); });
    newSelectedAccounts.unshift(selectedAccounts[0]);
    return {
        mutatedAccountsWithErrors: failingMutations,
        newSelectedAccounts: newSelectedAccounts,
        accountsMutationErrors: "forms.errors.page.notAllProfilesUpdated",
    };
};
export default checkFailingMutations;
